import { AdministracionRepository } from './administracion.repository';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { actualizarHTMLRequest, BuscarVacacionesByEmplRequest, TnsVacacionesRequest, TnsVacMasivasRequest, ValidarDiasAdelatoVacacionesRequest, ValidarDiasVacacionesRequest } from '../vacaciones/domain/vacaciones.request';
import { actualizarHTMLResponse, buscarVacacionesByEmplResponse, TnsVacacionesMasivasResponse, TransaccionVacacionesResponse, ValidarAdelantoVacacionesResponse, ValidarVacacionesResponse } from '../vacaciones/domain/vacaciones.response';
import { BuscarSolicitudesVacacionesRequest, getSaldoVacacionalRequest, TnsGestionVacacionesRequest } from '../gestion-vacaciones/domain/gestion-vacaciones.request';
import { BuscarSolicitudesVacacionesResponse, getSaldoVacacionalResponse, TnsGestionVacacionesResponse } from '../gestion-vacaciones/domain/gestion-vacaciones.response';
import { buscarDescansoMedicoRequest, ocrDescansoMedicoRequest, tnsDiagnosticoRequest } from '../descansos-medicos/domain/descansos-medicos.request';
import { buscarDescansoMedicoResponse, ocrDescansoMedicoResponse, tnsDiagnosticoResponse } from '../descansos-medicos/domain/descansos-medicos.response';
import { formatoCorreoRequest } from 'src/app/comercial/mantenimiento/domain/request/mantenimiento-request';
import { formatoCorreoResponse } from 'src/app/comercial/mantenimiento/domain/response/mantenimiento-response';
import { ContratosTNSRequest, getGestionContratosRequest } from '../gestion-de-contratos/domain/gestion-contratos.request';
import { BuscarSolicitudesContratosResponse, TnsContratosResponse } from '../gestion-de-contratos/domain/gestion-contratos.response';

@Injectable({
  providedIn: 'root'
})
export class AdministracionService implements AdministracionRepository {

  constructor(
    private readonly http: HttpClient
  ) { }

  //#region MANT VACACIONES
  ListarVacacionesByEmpl(fd: BuscarVacacionesByEmplRequest): Observable<buscarVacacionesByEmplResponse> {
    return this.http.post<buscarVacacionesByEmplResponse>(`${environment.PATH_API}/administracion/getVacacionesByEmpl`, fd);
  }
  ValidarDiasVacaciones(fd: ValidarDiasVacacionesRequest): Observable<ValidarVacacionesResponse> {
    return this.http.post<ValidarVacacionesResponse>(`${environment.PATH_API}/administracion/validateDiasVacaciones`, fd);
  }
  TransaccionTnsVacaciones(fd: TnsVacacionesRequest): Observable<TransaccionVacacionesResponse> {
    return this.http.post<TransaccionVacacionesResponse>(`${environment.PATH_API}/administracion/transaccionVacaciones`, fd);
  }
  ValidarDiasAdelantoVacaciones(fd: ValidarDiasAdelatoVacacionesRequest): Observable<ValidarAdelantoVacacionesResponse> {
    return this.http.post<ValidarAdelantoVacacionesResponse>(`${environment.PATH_API}/administracion/validateDiasAdelantoVacaciones`, fd);
  }
  //#endregion

  //#region GESTIÓN VACACIONES
  ListarSolicitudesVacaciones(fd: BuscarSolicitudesVacacionesRequest): Observable<BuscarSolicitudesVacacionesResponse> {
    return this.http.post<BuscarSolicitudesVacacionesResponse>(`${environment.PATH_API}/administracion/getSolicitudesVacaciones`, fd);
  }
  TransaccionGestionVacaciones(fd: TnsGestionVacacionesRequest): Observable<TnsGestionVacacionesResponse> {
    return this.http.post<TnsGestionVacacionesResponse>(`${environment.PATH_API}/administracion/tnsGestionVacaciones`, fd);
  }
  RegistrarVacacionesImpoMasiva(fd: TnsVacMasivasRequest): Observable<TnsVacacionesMasivasResponse> {
    return this.http.post<TnsVacacionesMasivasResponse>(`${environment.PATH_API}/administracion/tnsImpoVacasMasivas`, fd);
  }
  ListarSaldoVacaciones(fd: getSaldoVacacionalRequest): Observable<getSaldoVacacionalResponse> {
    return this.http.post<getSaldoVacacionalResponse>(`${environment.PATH_API}/administracion/getSaldoVacacional`, fd);
  }
  //#endregion

  //#region MANT DESCANSOS MÉDICOS
  ocrDescansoMedico(fd: ocrDescansoMedicoRequest): Observable<buscarDescansoMedicoResponse> {
    return this.http.post<buscarDescansoMedicoResponse>(`${environment.PATH_API}/administracion/lectorDescansoMedico`, fd);
  }
  obtenerDescansosMedicos(fd: buscarDescansoMedicoRequest): Observable<ocrDescansoMedicoResponse> {
    return this.http.post<ocrDescansoMedicoResponse>(`${environment.PATH_API}/administracion/getDescansosMedicosByEmpl`, fd);
  }
  TransaccionDiagnostico(fd: tnsDiagnosticoRequest): Observable<tnsDiagnosticoResponse> {
    return this.http.post<tnsDiagnosticoResponse>(`${environment.PATH_API}/generales/insertarTipo`, fd);
  }
  // TransaccionDescansoMedico(fd: tnsDiagnosticoRequest): Observable<tnsDiagnosticoResponse> {
  //   return this.http.post<tnsDiagnosticoResponse>(`${environment.PATH_API}/administracion/tnsDiagnosticoDM`, fd);
  // }
  //#endregion
  getFormatoHtml(fd: formatoCorreoRequest): Observable<formatoCorreoResponse> {
    return this.http.post<formatoCorreoResponse>(`${environment.PATH_API}/generales/getFormatoHtml`, fd);
  }
  setFormatoHtml(fd: actualizarHTMLRequest): Observable<actualizarHTMLResponse> {
    return this.http.post<actualizarHTMLResponse>(`${environment.PATH_API}/comercialvarios/guardarFormatoHtml`, fd);
  }
  //#region MANT CONTRATOS
  TransaccionContratos(fd: ContratosTNSRequest): Observable<TnsContratosResponse> {
    return this.http.post<TnsContratosResponse>(`${environment.PATH_API}/administracion/tnsContratos`, fd);
  }
  ListarContratosEmpl(fd: getGestionContratosRequest): Observable<BuscarSolicitudesContratosResponse> {
    return this.http.post<BuscarSolicitudesContratosResponse>(`${environment.PATH_API}/administracion/getGestionContratos`, fd);
  }
  //#endregion
}